import React from 'react';
import Layout from '../utils/layout';
import Landing from '../components/scenes/Landing/Landing';

export default () => (
  <Layout>
    <Landing />
  </Layout>
);
